import { get } from './apiService';

/**
 * Get active orders for the courier monitor, split into "preparing" / "ready" buckets
 * @param {string} organizationId
 * @returns {Promise<{preparing: Array, ready: Array}>}
 */
export async function getCourierMonitorOrders(organizationId) {
  return await get(`/courier-monitor/${organizationId}`, { requireAuth: false });
}
